import { connect } from "react-redux";

import GlobalBreakdownChart from "../../components/visualizations/global_breakdown_chart";
import { onExportDefault } from "../../actions/slide_decks";

const mapStateToProps = (state) => {
  const ld = state.main.loading.loadedData;
  if (!(ld.mainChart)) { return {}; }

  const dataAndOptions = ld.mainChart;
  const countryName = state.main.filters.country.selectedValue ? state.main.filters.country.selectedValue.value : null;
  const currentYear = state.main.filters.year.selectedValue.value;
  const title = `Cities in ${countryName} ${currentYear} tariff comparison`;
  const showExportButton = !state.main.slideDecks.slideDeckBeingSaved;

  return { dataAndOptions, title, showExportButton };
};

const mapDispatchToProps = dispatch => ({
  exportChart: onExportDefault(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalBreakdownChart);
